import React, { useState } from "react";
import { Marker, Popup } from "react-map-gl/mapbox";
import iconTruck from "../assets/AT_l.png";
import iconCargoTruck from "../assets/cargoTruck.svg";
import iconCargoTruck2 from "../assets/cargoTruck22.png";
import iconShovel from "../assets/excavator.png";
import iconDozer from "../assets/dozerIcon.png";
import iconGrader from "../assets/graderIcon.png";
import iconLoader from "../assets/loaderTopView.svg";

const GpsPositionMarker = ({
  coordinates,
  markerName,
  isActive,
  onClick,
  angle,
  equipmentType,
}) => {
  const [showPopup, setShowPopup] = useState(false);

  const config = {
    Shovel: { src: iconShovel, className: "w-5 h-14", offset: 0 },
    Truck: { src: iconTruck, className: "w-4 h-10", offset: 15 },
    cargoTruck: { src: iconCargoTruck, className: "w-4 h-16", offset: 25 },
    cargoTruck2: { src: iconCargoTruck2, className: "w-12 h-20", offset: 25 },
    Dozer: { src: iconDozer, className: "w-7 h-11", offset: 0 },
    Grader: { src: iconGrader, className: "w-7 h-14", offset: 15 },
    Loader: { src: iconLoader, className: "w-14 h-14", offset: 0 },
    Backhoe: { src: iconDozer, className: "w-7 h-11", offset: 20 },
  };

  // Si no existe el tipo, usa uno por defecto
  const { src, className, offset } = config[equipmentType] || {
    src: iconTruck,
    className: "w-6 h-8",
    offset: 20,
  };

  const handleClick = (e) => {
    e.stopPropagation(); // evita que el click se propague al mapa
    setShowPopup(!showPopup);
  };

  // distancia desde la punta al centro

  const rad = (angle * Math.PI) / 180;

  const x = Math.sin(rad) * offset;
  const y = Math.cos(rad) * offset;

  const labelDistance = offset + 40;

  const labelX = -Math.sin(rad) * labelDistance;
  const labelY = Math.cos(rad) * labelDistance;

  const normalizedAngle = ((angle % 360) + 360) % 360;

  const isVertical =
    normalizedAngle >= 315 ||
    normalizedAngle <= 45 ||
    (normalizedAngle >= 135 && normalizedAngle <= 225);

  const labelOffsetY = isVertical ? 43 : 30;


  return (
    <>
      <Marker
        longitude={coordinates.longitude}
        latitude={coordinates.latitude}
        anchor="center"
      >
        <div className="relative flex items-center justify-center">
          {/* Punto exacto de la coordenada */}

          <img
            src={src}
            className={className}
            alt={markerName}
            style={{
              transform: `
      translate(${-x}px, ${y}px)
      rotate(${angle}deg)
    `,
            }}
          />

          {/* Label separado del punto GPS */}

          <div
            className="absolute px-1 py-0.5 bg-black text-white rounded shadow text-xs whitespace-nowrap"
            style={{
              transform: `translate(calc(-0% - ${x}px), ${y + labelOffsetY}px)`,
            }}
          >
            {markerName}
          </div>
        </div>
      </Marker>

      {/* Popup al hacer click */}
      {showPopup && (
        <Popup
          longitude={coordinates.longitude}
          latitude={coordinates.latitude}
          anchor="top"
          closeOnClick={true}
          closeButton={false}
        >
          <div className="text-sm">
            <strong>{markerName}</strong>
            <p></p>
          </div>
        </Popup>
      )}
    </>
  );
};

export default GpsPositionMarker;
